import { ACTION } from "src/util/utils";
import {
  KEYS,
  MODULE_KEY,
} from "../UndoInventoryPost/action";

const initialState = {
  data: [] as any[],
  loading: false,
  error: null as any,
};
export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];

export const InventoryPostLocationsReducer = (
  state = initialState,
  { type, payload }: any
) => {
  switch (type) {
    
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };

    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: [...payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAILED]:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};